var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qqMapSelectPoint',{attrs:{"mapcenter":_vm.centerLatLng,"oldmarker":_vm.oldMarker},on:{"mapclick":_vm.pointChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }